module.exports = __webpack_public_path__ + "img/cp3-4.e225af20.jpg";